import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { Options } from "ng5-slider";
import { TopupServiceService } from '../Services/topup-service.service';
import { CookieService } from '../Services/cookie';
import { AmountFormatterPipe } from '../pipes/amount-formatter.pipe';
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { CardServiceService } from '../Services/card-service.service';
import { AdditionalDocService } from '../Services/additional-doc.service';


@Component({
  selector: 'app-card-limit-permanent',
  templateUrl: './card-limit-permanent.component.html',
  standalone:false,
  styleUrls: ['./card-limit-permanent.component.scss']
})
export class CardLimitPermanentComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

 
  value: number = 0;
  minmumValue: number = 0;
  requestedLimit: string;
  minmum: string;
  internalId: string;
  SaveNEwLmt: any;
  DocConfig: any;
  highValue: number=500000;
  options: Options    ={
    floor: 0,
    ceil: this.highValue
  }

  constructor(private _router: Router, private location: Location, private common: CommonService, public auth: AuthService, public cardService: CardServiceService,
    private amountpipe: AmountFormatterPipe, private cookieService: CookieService, public topupservice: TopupServiceService,
   ) {

   
    }

  async ngOnInit(): Promise<any> {
    this.common.presentLoading();

    this.auth.accessToken = await this.common.Get("token");

    await this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
       if (data?.response?.code == 1) {
        await this.common.hideLoading();

       } 
       else {
         await this.common.hideLoading();
         this.common.ParseErrorAlert("", "", this._router, data);
       }
     })
 
    let a =await this.cookieService.get("AutoTempLimitObj", false);
    if (a) {
      this.cardService.AutoTempLimitObj = JSON.parse(a);
    }

    let Id = await this.cookieService.get("internalid", true);
    if (Id) {

      this.internalId = Id;

    }


    let r =await this.cookieService.get("requestedLimit", false);

    if (r) {

      this.requestedLimit = r;
      this.minmum = this.requestedLimit;
      this.minmumValue = Number(this.requestedLimit);

      this.common.hideLoading();


      this.options = {
        floor: 0,
        ceil: this.highValue,
        //ceil:this.minmumValue
        // animate: true,
        // maxRange: this.highValue
      // enforceRange: false/
      };
    }

  

  }

  valueChange(e) {

    let num = e.toString();
    this.minmum = this.amountpipe.transform(num);

    if(!isNaN(e)){

      // this.highValue = Number(this.minmumValue);
      this.minmumValue = Number(e);


    }
    else{

      // this.highValue = this.minmumValue;
      this.minmumValue = e;


    }

    let newOptions: Options = Object.assign({}, this.options);
    // newOptions.floor = this.minmumValue ;

    newOptions.floor = 0;
      newOptions.ceil = this.highValue ;
    //  newOptions.ceil = this.minmumValue 

    this.options = newOptions;

  }

  back() {
    this.location.back()
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  Valid() {
    if (Number(this.requestedLimit) != this.minmumValue) {
      return false;
    }
    else {
      return true;
    }
  }


  SaveNewLimit() {

    this.common.presentLoading();
    let body = {
      CardId: this.internalId,
      limitType: "TEMPLIMIT", // PERLIMIT for permanent, TEMPLIMIT for temporary limit static
      NewLimit: this.minmum,
      RequestId: this.cardService.AutoTempLimitObj.limitRequestId

    }
    this.cardService.SaveNewLimit(body, this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {
        this.common.hideLoading();
      
        this.cookieService.set("NewLimit",this.minmum,true);
        this.SaveNEwLmt = res.response.content;

        this.showModal(2);
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert("", "OK", this._router, res);
      }
    })
  }
  cardUploadDocument() {
    this._router.navigateByUrl("/CardUploadDocument");

 

  }



}
